import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import "./AppLayout.css";
import Sidebar from "../Sidebar/Sidebar";
import { IconMenu } from "../Icons/Icons";
import { useAuth } from "../Auth/AuthContext";
import logoBranca from "../../img/logos/logo-btk-white.svg";

const SIDEBAR_ID = "menu-lateral";
const CHAVE_RECOLHIDA = "erp-btk:sidebar-recolhida";

// localStorage pode estar bloqueado (aba anonima, politica do navegador):
// nesse caso o menu so nao lembra a preferencia.
function lerRecolhida() {
  try {
    return localStorage.getItem(CHAVE_RECOLHIDA) === "true";
  } catch {
    return false;
  }
}

function salvarRecolhida(valor) {
  try {
    localStorage.setItem(CHAVE_RECOLHIDA, String(valor));
  } catch {
    // preferencia nao persistida
  }
}

export default function AppLayout() {
  const { usuario, sair } = useAuth();
  const [recolhida, setRecolhida] = useState(lerRecolhida);
  const [menuAberto, setMenuAberto] = useState(false);
  const [saindo, setSaindo] = useState(false);
  const { pathname } = useLocation();
  const botaoMenuRef = useRef(null);
  const mainRef = useRef(null);
  const menuAbertoRef = useRef(menuAberto);
  menuAbertoRef.current = menuAberto;

  useEffect(() => {
    salvarRecolhida(recolhida);
  }, [recolhida]);

  const fecharMenu = useCallback(() => {
    setMenuAberto(false);
    botaoMenuRef.current?.focus();
  }, []);

  // Ao navegar pelo drawer, fecha o menu e leva o foco para o conteudo novo.
  useEffect(() => {
    if (menuAbertoRef.current) {
      setMenuAberto(false);
      mainRef.current?.focus();
    }
  }, [pathname]);

  useEffect(() => {
    if (!menuAberto) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") fecharMenu();
    };

    document.addEventListener("keydown", handleKeyDown);
    document.body.classList.add("menu-aberto");
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.classList.remove("menu-aberto");
    };
  }, [menuAberto, fecharMenu]);

  // Sem sessao, a RotaProtegida leva para o login.
  const handleSair = () => {
    setSaindo(true);
    sair();
  };

  return (
    <div className={`app-shell${recolhida ? " app-shell--recolhida" : ""}`}>
      <a className="skip-link" href="#conteudo">
        Pular para o conteúdo
      </a>

      <div className="mobile-topbar">
        <button
          ref={botaoMenuRef}
          type="button"
          className="sidebar-icon-button"
          aria-label="Abrir menu"
          aria-expanded={menuAberto}
          aria-controls={SIDEBAR_ID}
          onClick={() => setMenuAberto(true)}
        >
          <IconMenu />
        </button>
        <Link to="/" className="mobile-topbar-brand">
          <img src={logoBranca} alt="BTK Solutions – início" />
        </Link>
      </div>

      <Sidebar
        id={SIDEBAR_ID}
        recolhida={recolhida}
        onAlternarRecolhida={() => setRecolhida((atual) => !atual)}
        aberta={menuAberto}
        onFechar={fecharMenu}
        usuario={usuario}
        onSair={handleSair}
        saindo={saindo}
      />

      {menuAberto && (
        <div className="sidebar-overlay" aria-hidden="true" onClick={fecharMenu} />
      )}

      <main id="conteudo" ref={mainRef} className="app-main" tabIndex={-1}>
        <Outlet />
      </main>
    </div>
  );
}
